var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6706 6.66846H8.33724C6.49629 6.66846 5.00391 8.16084 5.00391 10.0018V33.3351C5.00391 35.1761 6.49629 36.6685 8.33724 36.6685H31.6706C33.5115 36.6685 35.0039 35.1761 35.0039 33.3351V10.0018C35.0039 8.16084 33.5115 6.66846 31.6706 6.66846Z",
    stroke: "#2D2C2C",
    strokeWidth: 1.59995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.666 3.3335V10.0002",
    stroke: "#2D2C2C",
    strokeWidth: 1.59995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3379 3.3335V10.0002",
    stroke: "#2D2C2C",
    strokeWidth: 1.59995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00391 16.6709H35.0039",
    stroke: "#2D2C2C",
    strokeWidth: 1.59995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.936efbc41f2ae182b98779d05a8b7ee0.svg";
export { ForwardRef as ReactComponent };